import { Channel } from '@/Enums/Channel.enum';
import ForecasterControlSection from '@/Enums/Forecaster/ControlSection.enum';
import type { IDoohFilterVenueType } from '@/Interfaces/Forecaster/Dooh.interface';
import { forecasterControlSections } from '@/constants/forecaster';
import { useAppSelector } from '@/store/hooks';
import { selectIsProductSelectionCardHidden } from '@/store/selectors/currentWhitelabel.selectors';
import { ElementType, useMemo } from 'react';
import AdFormat from '../AdFormat';
import Audience from '../Audience';
import DealGroupsSection from '../DealGroups';
import Duration from '../Duration';
import GamCreativeSize from '../GamCreativeSize';
import GamVideoPosition from '../GamVideoPosition';
import ProductSelection from '../ProductSelection';
import VenueType from '../VenueType';

const ComponentMap: Partial<Record<ForecasterControlSection, ElementType>> = {
  [ForecasterControlSection.Audience]: Audience,
  [ForecasterControlSection.Products]: ProductSelection,
  [ForecasterControlSection.DoohVenueType]: VenueType,
  [ForecasterControlSection.DoohAdFormat]: AdFormat,
  [ForecasterControlSection.Duration]: Duration,
  [ForecasterControlSection.DealGroups]: DealGroupsSection,
  [ForecasterControlSection.GamVideoPosition]: GamVideoPosition,
  [ForecasterControlSection.GamCreativeSize]: GamCreativeSize,
};

interface IProps {
  currentChannel:
    | Channel.Dooh
    | Channel.CTV
    | Channel.OLV
    | Channel.Audio
    | Channel.Gaming
    | Channel.GamVideo
    | Channel.GamDisplay;
  filterVenueTypes?: IDoohFilterVenueType[];
}

const ControlComponents = ({ currentChannel, filterVenueTypes }: IProps) => {
  const controlProps = useMemo(() => ({ currentChannel, filterVenueTypes }), [currentChannel, filterVenueTypes]);
  const isProductSelectionCardHidden = useAppSelector(selectIsProductSelectionCardHidden);

  const controls = useMemo(() => {
    return forecasterControlSections[currentChannel] || forecasterControlSections.default;
  }, [currentChannel]);

  return controls.map(control => {
    if (control === ForecasterControlSection.Products && isProductSelectionCardHidden) {
      return null;
    }
    const Component = ComponentMap[control];
    if (!Component) {
      return null;
    }
    return <Component {...controlProps} key={control} />;
  });
};

export default ControlComponents;
